import React from 'react';

export const Button = ({ children, onClick, variant = 'primary', className = "", disabled = false, icon: Icon }) => {
    const styles = {
        primary: "bg-blue-600 hover:bg-blue-700 text-white shadow-md",
        secondary: "bg-gray-100 hover:bg-gray-200 text-gray-700 dark:bg-slate-700 dark:hover:bg-slate-600 dark:text-slate-200",
        danger: "bg-red-50 text-red-600 border border-red-200 hover:bg-red-100"
    };
    
    return (
        <button 
            onClick={onClick} 
            disabled={disabled} 
            className={`px-4 py-2.5 rounded-lg font-bold text-sm transition-all flex items-center justify-center gap-2 ${styles[variant]} ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
            {Icon && <Icon size={16}/>}
            {children}
        </button>
    );
};
export default Button;
